import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import FormCreateVehicleTransfer from "../forms/FormCreateVehicleTransfer";
import { createVehiclesTransfer } from "@/common/services/vehiclesTransfer.api";

type Props = {
  onClose?: () => void;
  onSave: () => void;
};

export default function ModalCreateVehicleTransfer(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();

  const handleCloseModal = () => {
    props.onClose && props.onClose();
  };

  async function handleSubmit(dataToSave) {
    try {
      const result = await createVehiclesTransfer(dataToSave);

      const { ok, data } = result;

      if (ok && data) {
        props.onSave();
        notifySuccess(`Transferencia cadastrada!`);
      }
      if (!result.ok) {
        notifyError(result.message as string);
      }

      return data;
    } catch (err) {
      console.log(err);
      notifyError("Erro ao tentar salvar cliente, tente novamente");
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }],
      };
    }
  }

  return (
    <Modal show={true} onClose={() => handleCloseModal()}>
      <Modal.Header className="text-black">
        <h2 className="text-black">{"Nova Transferência de Veículos"}</h2>
      </Modal.Header>
      <Modal.Body
        className="text-black"
        style={{
          minHeight: "calc(50vh - 200px)",
          height: "calc(50vh - 200px)",
        }}
      >
        <FormCreateVehicleTransfer onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  );
}
